/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */
import React from 'react';
import { X } from 'lucide-react';
import './onboarding.css';

interface TutorialPromptProps {
  isVisible: boolean;
  onDismiss: () => void;
  onStart: () => void;
}

const TutorialPrompt: React.FC<TutorialPromptProps> = ({
  isVisible,
  onDismiss,
  onStart
}) => {
  if (!isVisible) return null;

  return (
    <div className="tutorial-prompt">
      <button
        onClick={onStart}
        className="hover:opacity-80 transition-opacity cursor-pointer font-semibold"
        style={{ background: 'none', border: 'none', color: 'inherit', padding: 0 }}
        title="Click to start tutorial"
      >
        Start Here!
      </button>
      <button
        onClick={onDismiss}
        className="ml-1 hover:opacity-70 transition-opacity"
        title="Dismiss"
        style={{ background: 'none', border: 'none', color: 'inherit', padding: 0 }}
      >
        <X size={12} />
      </button>
    </div>
  );
};

export default TutorialPrompt;